import { apiClient } from '@/api/client';

/** Matches the Backend's two public routes 1:1 (`02-design.md` §10). */
export type PublicApplicationType = 'investor' | 'trusted-partner';

/** The six fields both public Apply-forms collect. */
export interface SubmitApplicationInput {
  firstName: string;
  lastName: string;
  companyName: string;
  businessEmail: string;
  website: string;
  /** MYN-201 (FR-160). Free text - state/country support non-US formats like "England". */
  phone: string;
  /**
   * The three location fields the Investors form collects and the Trusted
   * Partners form does not (MYN-327, FR-322/FR-323). Optional here because
   * the two routes now take different shapes: the backend's trusted-partner
   * DTO rejects them outright under `forbidNonWhitelisted`, so they must be
   * absent - not blank - on that page's submission.
   */
  city?: string;
  state?: string;
  country?: string;
}

/**
 * Public Apply-form submission (MYN-80, FR-140). `@Public()` on the Backend -
 * reachable with no session. `type` selects the route (`/applications/investor`
 * or `/applications/trusted-partner`); the Backend stores it on the created
 * row verbatim. Resolves with no value - the Backend responds `201` with an
 * empty body, so the caller's own success state is all that's needed.
 */
export async function submitApplication(type: PublicApplicationType, input: SubmitApplicationInput): Promise<void> {
  await apiClient.post(`/applications/${type}`, input);
}
